import * as Yup from "yup";

function NRBvalidatior(nrb: string): boolean {
  if (!nrb || nrb.length < 1) return false;

  const cleanNrb = nrb.replace(/[^0-9]+/g, "");
  const weights = [
    1, 10, 3, 30, 9, 90, 27, 76, 81, 34, 49, 5, 50, 15, 53, 45, 62, 38, 89, 17,
    73, 51, 25, 56, 75, 71, 31, 19, 93, 57,
  ];

  if (cleanNrb.length !== 26) return false;

  const extendedNrb = cleanNrb + "2521";
  const rearrangedNrb = extendedNrb.substr(2) + extendedNrb.substr(0, 2);

  let sum = 0;
  for (let i = 0; i < 30; i++) {
    sum += parseInt(rearrangedNrb[29 - i]!) * weights[i]!;
  }

  return sum % 97 === 1;
}

const CustomReturnUserFormSchema = () => {
  return Yup.object().shape({
    accountNumber: Yup.string()
      .matches(/^[\d ]*$/, "Numer konta może zawierać wyłącznie cyfry")
      .test(
        "is_account_number",
        "Nieprawidłowy numer konta bankowego",
        function (value) {
          return NRBvalidatior(value || "");
        },
      ),
    name: Yup.string()
      .min(3, "Minimum 3 znaki")
      .max(60, "Maximum 60 znaków")
      .required("To pole jest wymagane"),
    phone: Yup.string()
      .matches(/^\d{9}$/, "Numer telefonu musi składać się z 9 cyfr")
      .required("To pole jest wymagane"),
    street: Yup.string()
      .min(3, "Minimum 3 znaki")
      .max(35, "Maximum 35 znaków")
      .required("To pole jest wymagane"),
    houseNumber: Yup.string()
      .min(1, "Minimum 1 znak")
      .max(10, "Maximum 10 znaków")
      .required("To pole jest wymagane"),
    apartmentNumber: Yup.string().max(10, "Maximum 10 znaków"),
    postCode: Yup.string()
      .matches(/^\d{2}-\d{3}$/, "Kod pocztowy musi być w formacie XX-XXX")
      .required("To pole jest wymagane"),
    city: Yup.string()
      .min(3, "Minimum 3 znaki")
      .max(17, "Maximum 17 znaków")
      .required("To pole jest wymagane"),
  });
};

export default CustomReturnUserFormSchema;
